import type { FaireProductEntity } from "../../entity_types/product";

export const p_vadrxe3yzb: FaireProductEntity = {
  token: "p_vadrxe3yzb",
  type: "product",
  name: "Sleep Gummies | Melatonin Gummies with Chamomile, Valerian",
  brandToken: "b_5071j6eb6g",
  brandName: "NutraChamps",
  imageUrl:
    "https://cdn.faire.com/fastly/e24d51517328809ca225114490e6c9d52cf4f364ccab9a3ae533af73fa1f0767.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a6fe215534dc3557c7bbd06301d70de2901f507e8249810cee343ce0e283fb9.jpeg",
    "https://cdn.faire.com/fastly/5e88b78fb48ba3d769374e1f6dc0d27c21ad1d32281d740a8f30d544c4e3d08a.jpeg",
    "https://cdn.faire.com/fastly/127b370d31c6dd640c30276b8235295ce3e17b81ea4e9195ae4f3d9b73b6ccf7.jpeg",
    "https://cdn.faire.com/fastly/46ca3898171f4aa440d3211e8cb852ac662e69d25a95506bfd96ddc13e49830a.jpeg",
    "https://cdn.faire.com/fastly/0dc2581cb7d6a190ee82c4da4769b93009d529c2ea7b3488fce0ccaa3e78d89e.jpeg",
  ],
  priceDollars: 11.37,
  description:
    "These delicious gummies are packed with gentle, soothing herbs and nutrients that will have you naturally drifting off into a deep, restful sleep with ease. A better tomorrow starts tonight.",
  tags: [],
  msrpDollars: 18.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:47.864Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
